/* Banner runtime — קובץ JS עצמאי ללא תלויות.
 * אותו קובץ נטען בעורך (import לצורך תופעת לוואי) ומוטמע כטקסט בתוך חבילת היצוא.
 * אנימציה דטרמיניסטית: מצב כל שכבה הוא פונקציה טהורה של הזמן. */
(function (g) {
  'use strict';
  var EASE = {
    linear: function (p) { return p; },
    easeIn: function (p) { return p * p * p; },
    easeOut: function (p) { var q = 1 - p; return 1 - q * q * q; },
    easeInOut: function (p) { return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; }
  };
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(name, p) { return (EASE[name] || EASE.linear)(clamp01(p)); }
  function lerp(a, b, p) { return a + (b - a) * p; }

  /** זמן בתוך הלולאה לפי זמן שחלף מתחילת הבאנר */
  function timeAt(doc, elapsed) {
    var d = doc.durationMs;
    if (elapsed < 0) elapsed = 0;
    if (doc.loops > 0 && elapsed >= d * doc.loops) {
      var ef = doc.endFrameMs == null ? d : Math.min(doc.endFrameMs, d);
      return { t: ef, loop: doc.loops - 1, finished: true };
    }
    var loop = Math.floor(elapsed / d);
    return { t: elapsed - loop * d, loop: loop, finished: false };
  }

  function totalMs(doc) { return doc.loops > 0 ? doc.durationMs * doc.loops : Infinity; }

  function trackFor(doc, id) {
    var ts = doc.animationTracks || [];
    for (var i = 0; i < ts.length; i++) if (ts[i].layerId === id) return ts[i];
    return null;
  }

  function applyTransition(tr, p, st, layer) {
    var e = ease(tr.easing || 'easeOut', p);
    if (tr.type === 'fade') st.opacity *= e;
    else if (tr.type === 'scale') { st.scale *= lerp(0.5, 1, e); st.opacity *= e; }
    else if (tr.type === 'slide') {
      var dist = tr.distance == null ? 40 : tr.distance, off = dist * (1 - e);
      if (tr.from === 'left') st.dx -= off;
      else if (tr.from === 'right') st.dx += off;
      else if (tr.from === 'top') st.dy -= off;
      else st.dy += off;
      st.opacity *= e;
    }
  }

  /** מצב שכבה בזמן t (ms בתוך לולאה). */
  function layerState(doc, layer, t) {
    var end = layer.endMs == null ? doc.durationMs : layer.endMs;
    var st = { visible: layer.visible !== false, opacity: layer.opacity == null ? 1 : layer.opacity, dx: 0, dy: 0, scale: 1, rotation: layer.rotation || 0 };
    var atEnd = layer.endMs == null && t >= doc.durationMs;
    if (t < layer.startMs || (t >= end && !atEnd)) { st.visible = false; return st; }
    var tr = trackFor(doc, layer.id);
    if (tr) {
      // keyframes: ערכים יחסיים; מתחילים מזהות ב-startMs
      var kfs = tr.keyframes || [];
      if (kfs.length) {
        var prev = { atMs: layer.startMs, props: { dx: 0, dy: 0, scale: 1, opacity: 1, rotation: 0 } };
        var cur = { dx: 0, dy: 0, scale: 1, opacity: 1, rotation: 0 };
        var done = false;
        for (var i = 0; i < kfs.length && !done; i++) {
          var k = kfs[i], kp = {};
          for (var key in cur) kp[key] = k.props[key] == null ? prev.props[key] : k.props[key];
          if (t < k.atMs) {
            var span = k.atMs - prev.atMs, p = span <= 0 ? 1 : ease(k.easing || 'easeInOut', (t - prev.atMs) / span);
            for (var key2 in cur) cur[key2] = lerp(prev.props[key2], kp[key2], p);
            done = true;
          } else { prev = { atMs: k.atMs, props: kp }; }
        }
        if (!done) cur = prev.props;
        st.dx += cur.dx; st.dy += cur.dy; st.scale *= cur.scale; st.opacity *= cur.opacity; st.rotation += cur.rotation;
      }
      if (tr.enter && tr.enter.type !== 'none' && tr.enter.durationMs > 0) {
        var pe = (t - layer.startMs) / tr.enter.durationMs;
        if (pe < 1) applyTransition(tr.enter, pe, st, layer);
      }
      if (tr.exit && tr.exit.type !== 'none' && tr.exit.durationMs > 0 && layer.endMs != null) {
        var px = (end - t) / tr.exit.durationMs;
        if (px < 1) applyTransition(tr.exit, px, st, layer);
      }
    }
    if (st.opacity <= 0.001) st.opacity = 0;
    return st;
  }

  var JUSTIFY = { top: 'flex-start', middle: 'center', bottom: 'flex-end' };

  function fontFamilyFor(c, assets) {
    var fam = '';
    if (c.fontAssetId && assets && assets[c.fontAssetId]) fam = '"' + assets[c.fontAssetId].family + '",';
    return fam + (c.fontFamily ? '"' + c.fontFamily + '",' : '') + 'Arial,sans-serif';
  }

  function styleText(el, c, assets) {
    el.style.display = 'flex';
    el.style.flexDirection = 'column';
    el.style.justifyContent = JUSTIFY[c.verticalAlign || 'top'];
    var inner = el.firstChild;
    inner.textContent = c.text;
    inner.setAttribute('dir', c.direction || 'auto');
    inner.style.fontFamily = fontFamilyFor(c, assets);
    inner.style.fontWeight = String(c.fontWeight);
    inner.style.fontSize = c.fontSize + 'px';
    inner.style.lineHeight = String(c.lineHeight);
    inner.style.textAlign = c.align;
    inner.style.color = c.color;
    inner.style.letterSpacing = (c.letterSpacing || 0) + 'px';
    inner.style.whiteSpace = 'pre-wrap';
    inner.style.overflowWrap = 'break-word';
    inner.style.unicodeBidi = 'plaintext';
  }

  function createLayerEl(doc, layer, assets) {
    var el = document.createElement('div');
    el.className = 'bb-layer bb-' + layer.type;
    el.setAttribute('data-layer-id', layer.id);
    el.style.position = 'absolute';
    el.style.boxSizing = 'border-box';
    el.style.transformOrigin = '50% 50%';
    var c = layer.content;
    if (layer.type === 'text' || layer.type === 'button') {
      var inner = document.createElement('div');
      inner.className = 'bb-text';
      el.appendChild(inner);
      styleText(el, c, assets);
      if (layer.type === 'button') {
        el.style.background = c.fill;
        el.style.borderRadius = (c.radius || 0) + 'px';
        el.style.justifyContent = 'center';
        el.style.cursor = 'pointer';
        el.setAttribute('role', 'button');
      }
    } else if (layer.type === 'image') {
      var a = assets && assets[c.assetId];
      el.style.backgroundImage = a ? 'url("' + a.url + '")' : 'none';
      el.style.backgroundRepeat = 'no-repeat';
      el.style.backgroundSize = c.fit;
      el.style.backgroundPosition = (c.focalX * 100) + '% ' + (c.focalY * 100) + '%';
      el.setAttribute('role', 'img');
      if (!a) el.setAttribute('data-missing-asset', c.assetId);
    } else if (layer.type === 'shape') {
      el.style.background = c.fill;
      el.style.borderRadius = (c.radius || 0) + 'px';
      if (c.borderColor && c.borderWidth) el.style.border = c.borderWidth + 'px solid ' + c.borderColor;
    }
    return el;
  }

  function positionEl(el, layer, st) {
    el.style.left = layer.x + 'px';
    el.style.top = layer.y + 'px';
    el.style.width = layer.width + 'px';
    el.style.height = layer.height + 'px';
    el.style.zIndex = String(layer.zIndex);
    el.style.opacity = String(st.opacity);
    el.style.visibility = st.visible ? 'visible' : 'hidden';
    el.style.transform = 'translate(' + st.dx + 'px,' + st.dy + 'px) rotate(' + st.rotation + 'deg) scale(' + st.scale + ')';
  }

  /**
   * mount(root, doc, assets, opts) — assets: { [assetId]: { url, family? } }
   * opts.autoplay (ברירת מחדל true), opts.onTick(elapsed)
   */
  function mount(root, doc, assets, opts) {
    opts = opts || {};
    var raf = (g.requestAnimationFrame || function (f) { return setTimeout(function () { f(Date.now()); }, 16); });
    var caf = (g.cancelAnimationFrame || clearTimeout);
    root.innerHTML = '';
    root.style.position = 'relative';
    root.style.overflow = 'hidden';
    root.style.width = doc.width + 'px';
    root.style.height = doc.height + 'px';
    root.style.backgroundColor = doc.background.color;
    if (doc.background.assetId && assets[doc.background.assetId]) {
      root.style.backgroundImage = 'url("' + assets[doc.background.assetId].url + '")';
      root.style.backgroundSize = doc.background.fit;
      root.style.backgroundPosition = 'center';
    }
    var els = {};
    for (var i = 0; i < doc.layers.length; i++) {
      var l = doc.layers[i];
      var el = createLayerEl(doc, l, assets);
      els[l.id] = el;
      root.appendChild(el);
    }
    var elapsed = 0, playing = false, startAt = 0, handle = null, finished = false;
    function render(ms) {
      var ta = timeAt(doc, ms);
      finished = ta.finished;
      for (var j = 0; j < doc.layers.length; j++) {
        var layer = doc.layers[j];
        positionEl(els[layer.id], layer, layerState(doc, layer, ta.t));
      }
      if (opts.onTick) opts.onTick(ms, ta);
      return ta;
    }
    function frame(now) {
      if (!playing) return;
      elapsed = now - startAt;
      var ta = render(elapsed);
      if (ta.finished) { playing = false; if (opts.onEnd) opts.onEnd(); return; }
      handle = raf(frame);
    }
    function now() { return (g.performance && g.performance.now) ? g.performance.now() : Date.now(); }
    var ctl = {
      play: function () { if (playing) return; if (finished) elapsed = 0; playing = true; startAt = now() - elapsed; handle = raf(frame); },
      pause: function () { playing = false; if (handle != null) caf(handle); },
      seek: function (ms) { ctl.pause(); elapsed = Math.max(0, ms); render(elapsed); },
      reset: function () { ctl.pause(); elapsed = 0; finished = false; render(0); },
      getElapsed: function () { return elapsed; },
      isPlaying: function () { return playing; },
      isFinished: function () { return finished; },
      totalMs: function () { return totalMs(doc); },
      elements: els,
      destroy: function () { ctl.pause(); root.innerHTML = ''; }
    };
    render(0);
    if (opts.autoplay !== false) ctl.play();
    return ctl;
  }

  g.BBRuntime = { timeAt: timeAt, totalMs: totalMs, layerState: layerState, mount: mount, ease: ease, version: '1.0.0' };
})(typeof window !== 'undefined' ? window : globalThis);
